import { Helmet } from "react-helmet-async";
import Screen from "../Layouts/Screen/Screen";
import { Server } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useMessage } from "../../global-components/src";
import axios from "axios";
import { useAuth } from "../../global-components/src";
import { errorMessage } from "../../utils/TextManagerTwo";
import { PACOCA_API_URL } from "../../global-components/src/utils/vars";
import { PostLoading } from "../../components/Post/post-loading";

interface RequestsType {
    requestsPerMonth: number;
    requestsPerDate: number;
    activeUsersPerMonth: number;
    activeUsersPerDate: number;
}

const Requests = () => {
    const observerRef = useRef<IntersectionObserver | null>(null);
    const endOfListRef = useRef<HTMLDivElement | null>(null);

    const [requests, setRequests] = useState<RequestsType | null>(null);
    const { setMessage } = useMessage();
    const [loading, setLoading] = useState(false);
    const { token } = useAuth();

    const formatNumber = (num: number) => {
        return num ? num.toLocaleString("pt-BR") : 0; // Ex: 12890 => 12.890
    };

    const loadData = async () => {
        const url = PACOCA_API_URL + `/moderators/requests`;

        if (loading) return;
        setLoading(true);

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            });

            setRequests(response.data);

        } catch (err: any) {
            const type = err?.response?.data?.type_message || "error";
            setMessage(errorMessage(err), type);
            console.error("Erro:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    return (
        <>
            <Screen paddingTopTitle={true} title="Requisições">
                <Helmet>
                    <title>Paçoca - Requisições</title>
                </Helmet>

                <PostLoading loading={loading} />

                {/* DADOS */}
                {requests && !loading && (
                    <div className="mt-5 user-select-none row text-center d-flex justify-content-center">

                        {/* Requisições Hoje */}
                        <div className="col-12 col-md-5 m-2 p-4 shadow-sm rounded bg-white">
                            <h5 className="fw-bold mb-2">Requisições Hoje</h5>
                            <p className="display-6 fw-bold text-primary">
                                {formatNumber(requests.requestsPerDate)}
                            </p>
                        </div>

                        {/* Requisições no Mês */}
                        <div className="col-12 col-md-5 m-2 p-4 shadow-sm rounded bg-white">
                            <h5 className="fw-bold mb-2">Requisições no Mês</h5>
                            <p className="display-6 fw-bold text-primary">
                                {formatNumber(requests.requestsPerMonth)}
                            </p>
                        </div>

                        {/* Usuários Ativos Hoje */}
                        <div className="col-12 col-md-5 m-2 p-4 shadow-sm rounded bg-white">
                            <h5 className="fw-bold mb-2">Usuários Ativos Hoje</h5>
                            <p className="display-6 fw-bold text-primary">
                                {formatNumber(requests.activeUsersPerDate)}
                            </p>
                        </div>

                        {/* Usuários Ativos no Mês */}
                        <div className="col-12 col-md-5 m-2 p-4 shadow-sm rounded bg-white">
                            <h5 className="fw-bold mb-2">Usuários Ativos no Mês</h5>
                            <p className="display-6 fw-bold text-primary">
                                {formatNumber(requests.activeUsersPerMonth)}
                            </p>
                        </div>
                    </div>
                )}

                {/* VAZIO */}
                {!requests && !loading && (
                    <div className="user-select-none row mt-5 text-center">
                        <span className="span-empty d-flex flex-column align-items-center w-100">
                            <Server className="icon-empty mb-2" size={42} />
                            <h3>Nenhuma requisição encontrada</h3>
                        </span>
                    </div>
                )}

                <p ref={endOfListRef}></p>
            </Screen>
        </>
    );
};

export default Requests;
